export default __webpack_public_path__ + "static/media/focus.cc33dc69.jpg";